import React, { useState } from "react";
import { Modal, ModalHeader } from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import { addPositionType } from "common/services/payments.service";
import Form from "./Form";
import { toast } from "react-toastify";

const AddPositionType: React.FC<{
  toggle: () => void;
  isModalOpen: boolean;
  fetchData: () => void;
}> = ({ toggle, isModalOpen, fetchData }) => {
  const [loading, setLoading] = useState<boolean>(false);
  // validation
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: "",
      category: {
        value: "",
        label: "",
      },
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Please enter name"),
      category: Yup.object().shape({
        value: Yup.string(),
        label: Yup.string(),
      }),
    }),
    onSubmit: async (values: any) => {
      const data = {
        data: {
          name: values["name"] ? values["name"].trim() : null,
          category: values["category"]["value"] || null,
        },
      };

      setLoading(true);
      try {
        await addPositionType(data);
        fetchData();
        validation.resetForm();
        toggle();
        toast.success("Position type added successfully", {});
      } catch (e: any) {
        toast.error("Position type creation failed", {});
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <Modal
      id="showModal"
      size="lg"
      isOpen={isModalOpen}
      toggle={toggle}
      centered
    >
      <ModalHeader className="bg-light p-3" toggle={toggle}>
        Add Position Type
      </ModalHeader>

      <Form
        validation={validation}
        isUpdate={false}
        loading={loading}
        toggle={toggle}
      />
    </Modal>
  );
};

export default AddPositionType;
